import { absolutePath } from "../../../../helpers/relativePath";
import AdminTaskListing from "./dashboard/AdminTaskListing";
import DisplayDailyTask from "./dashboard/DisplayDailyTask";
import { HOME_PAGE } from "../../../../helpers/routes";
import { PageTitle } from "../../../../../_metronic/layout/core";
import AssignedActivityList from "./activity/AssignedActivityList";
import NotificationList from "./dashboard/NotificationList";
import MorningPlannerList from "./dashboard/MorningPlannerList";
import RequestList from "./dashboard/RequestList";
import hasPermission, { actionsRole } from "../../auth/core/permission";
import TaskOverviewPanel from "./dashboard/TaskOverviewPanel";
import AdminPieChart from "./dashboard/AdminPieChart";
import { ChartsWidget1, ChartsWidget2, ChartsWidget3, ChartsWidget4, ChartsWidget5, ChartsWidget6, ChartsWidget7, ChartsWidget8 } from "_metronic/partials/widgets";

export const adminHomePage = {
  title: "Dashboard",
  path: absolutePath(HOME_PAGE),
  isSeparator: false,
  isActive: false,
};

const AdminMain = () => {
  return (
    <div>
      <PageTitle>Dashboard</PageTitle>
      
      <TaskOverviewPanel />
      <div className="row">
      
        <DisplayDailyTask />
        <AssignedActivityList />
        <NotificationList />
        {hasPermission(actionsRole.ADMIN) && <RequestList />}
      </div>
      <AdminTaskListing />
      <MorningPlannerList />
    </div>
  );
};

export default AdminMain;
